import { render } from "./Repli.vue?vue&type=template&id=5c5739e0"
import script from "./Repli.vue?vue&type=script&lang=js"
export * from "./Repli.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__